import styled from '@emotion/styled';
import MicrositeSection from '~/components/MicrositeSection';
import BetaSectionHeader from '~/editor/templates/beta/lib/BetaSectionHeader';
import { BLOCK_WYSIWYG_STYLE, type WysiwygBlockVariant } from '~/editor/blocks/wysiwyg/common';

const Body = styled(BLOCK_WYSIWYG_STYLE)`
	font-weight: 300;
`;

export default function WysiwygBlockBeta({ id, title, children }: WysiwygBlockVariant) {
	return (
		<MicrositeSection id={id} fill padding>
			{title && <BetaSectionHeader title={title} />}
			<Body>{children}</Body>
		</MicrositeSection>
	);
}
